import { render, staticRenderFns } from "./OtherMarketInstruments.vue?vue&type=template&id=084e4dac&scoped=true"
import script from "./OtherMarketInstruments.vue?vue&type=script&lang=js"
export * from "./OtherMarketInstruments.vue?vue&type=script&lang=js"
import style0 from "./OtherMarketInstruments.vue?vue&type=style&index=0&id=084e4dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084e4dac",
  null
  
)

export default component.exports